module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hcpSearchView"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('span', [_vm._v("Showing results from")]), _vm._v(" "), _c('mu-select-field', {
    model: {
      value: (_vm.filterType),
      callback: function($$v) {
        _vm.filterType = $$v
      },
      expression: "filterType"
    }
  }, [_c('mu-menu-item', {
    attrs: {
      "value": "education",
      "title": "Education"
    }
  }), _vm._v(" "), _c('mu-menu-item', {
    attrs: {
      "value": "resources",
      "title": "Resources"
    }
  })], 1)], 1), _vm._v(" "), _c('mu-card', [_c('mu-card-title', {
    attrs: {
      "title": ("Results for: \"" + (_vm.$route.params.search) + "\"")
    }
  }), _vm._v(" "), _c('mu-card-text', [(!_vm.hasResults) ? _c('p', [_vm._v("Could not find any results based on your search")]) : _vm._e(), _vm._v(" "), _c('mu-list', [_vm._l((_vm.results), function(item, index) {
    return (!_vm.isLoading) ? _c('div', {
      key: ("item-" + index),
      staticClass: "item"
    }, [_c('mu-list-item', {
      attrs: {
        "title": item.title
      },
      nativeOn: {
        "click": function($event) {
          return _vm.linkSearchItem(item.type, item.link)
        }
      }
    }, [_c('div', {
      staticClass: "icon",
      attrs: {
        "slot": "left"
      },
      slot: "left"
    }, [_c('mu-icon', {
      attrs: {
        "value": _vm.getSearchType(item.type).icon
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "mu-item-text",
      domProps: {
        "innerHTML": _vm._s(_vm.$sanitize(_vm.highlightKeyword(item.desc, [_vm.$route.params.search, _vm.$route.params.search + 's'])))
      }
    })]), _vm._v(" "), ((index + 1) !== _vm.results.length) ? _c('mu-divider', {
      attrs: {
        "inset": true
      }
    }) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _vm._l((10), function(item, index) {
    return (_vm.isLoading) ? _c('mu-list-item', {
      key: ("item-" + index)
    }, [_c('div', {
      attrs: {
        "slot": "describe"
      },
      slot: "describe"
    }, [_c('mu-linear-progress', {
      staticStyle: {
        "height": "15px",
        "width": "15%",
        "background": "#f1f1f1",
        "margin": "0 0 16px"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1), _vm._v(" "), _c('mu-linear-progress', {
      staticStyle: {
        "height": "20px",
        "width": "50%",
        "background": "#f1f1f1"
      },
      attrs: {
        "color": "#d9d9d9"
      }
    })], 1) : _vm._e()
  })], 2)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bb63748","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HealthCareProfessional/Search/Search.vue
// module id = 3069
// module chunks = 1